/* eslint-disable */

import type { ResourcesConfig } from 'aws-amplify';

import config from './config';

/**
 * Default DVV Cognito configuration for magic link authentication.
 * This is used for tenants and current landlords.
 */
export const dvvAuthConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      region: config.VITE_AMPLIFY_REGION || 'eu-central-1',
      userPoolClientId: config.VITE_AMPLIFY_APP_CLIENT_ID || '',
      userPoolId: config.VITE_AMPLIFY_USER_POOL_ID || '',
    },
  },
} as ResourcesConfig;

/**
 * WoningNet SSO Cognito configuration.
 * This is used for WoningNet admins and new landlords via SSO.
 * Only configured when SSO is enabled.
 */
export const woningNetSsoAuthConfig = (): ResourcesConfig => {
  return {
    Auth: {
      Cognito: {
        region: config.VITE_SSO_REGION || 'eu-central-1',
        userPoolClientId: config.VITE_SSO_APP_CLIENT_ID || '',
        userPoolId: config.VITE_SSO_USER_POOL_ID || '',
        loginWith: {
          oauth: {
            domain: config.VITE_SSO_DOMAIN,
            scopes: [
              'email',
              'openid',
              'aws.cognito.signin.user.admin',
              'profile',
            ],
            redirectSignIn: [config.VITE_SSO_REDIRECT_URL],
            redirectSignOut: [config.VITE_SSO_REDIRECT_URL],
            responseType: 'code',
          },
        },
      },
    },
  } as ResourcesConfig;
};

// Default export maintains backward compatibility
export default dvvAuthConfig;
